<template>
  <div class="field-wrapper field-wrapper--large field-wrapper--radio">
    <div :class="[field.cssClass]">
      <p
        v-if="field.labelPlacement !== 'hidden_label'"
        class="label label--radio"
      >
        {{ field.label }}<sup v-if="field.isRequired">*</sup>
      </p>

      <div class="field-group field-group--radio field-group--radio-gray">
        <div class="input-radio-wrapper">
          <template v-for="(item, choiceKey) in field.choices">
            <input
              :id="'choice-'+ formId + '_' + fieldKey + '-' + choiceKey"
              :class="[field.label.replace(/ /g,'_')]"
              v-model="choice"
              :value="item.value"
              :required="field.isRequired"
              :name="field.label.replace(/ /g,'_')"
              type="radio"
            >
            <label :for="'choice-' + formId + '_' + fieldKey + '-' + choiceKey">
              <span class="input-radio-text">{{item.text}}</span>
            </label>
          </template>
        </div>
      </div>

      <slot name="description"></slot>
      <slot name="error"></slot>
    </div>
  </div>
</template>

<script>
import store from '../store';
export default {
  store,
  name: "VFieldRadio",
  data () {
    return {
      choice: ''
    }
  },
  props: {
    formId: Number,
    field: Object,
    fieldKey: Number
  },

  mounted() {
    const preCheckedValue = this.field.choices.find(item => item.isSelected);

    if (preCheckedValue) {
      this.choice = preCheckedValue.value
    }

  },

  watch: {
    choice: {
      immediate: true,
      deep: false,
      handler (newValue) {
        store.commit(
            'UPDATE_USER_FORM_DATA' ,
            {'key': this.field.id, 'value': newValue})
      }
    }
  }

}
</script>
